import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  invalidTaxIdError: {
    description: 'error message to indicate that tax ID is invalid',
    defaultMessage: 'Please enter a valid {taxIdName} number',
    id: 'TGeHV6',
  },
  issuingAuthorityLabel: {
    description: 'label for issuing authority dropdown',
    defaultMessage: 'Issuing Authority',
    id: 'Jpldd2',
  },
  issuingAuthorityPlaceholder: {
    description: 'placeholder for issuing authority dropdown',
    defaultMessage: 'Select Country',
    id: '4argb1',
  },
});
